// // import React from "react";

// // export default function PoliticaEntrega() {
// //   return (
// //     <section className="container py-4">
// //       <h1>Política de Entrega e Devolução de Produtos e/ou Serviços</h1>
// //       <p>Última atualização: {new Date().toISOString().slice(0,10)}</p>

// //       <h2>Âmbito</h2>
// //       <p>
// //         Esta política aplica-se aos serviços prestados por <strong>Luciana Costa</strong> no website
// //         <strong> lucianacosta.cv</strong>, incluindo terapias presenciais e online, e a produtos digitais
// //         (ex.: e-books). A faturação e processamento de pagamentos são efetuados por <strong>MIT Solutions, Lda.</strong>
// //         (NIF 284004405), merchant de referência junto do SISP/Vinti4.
// //       </p>

// //       <h2>Serviços (Terapias)</h2>
// //       <ul>
// //         <li><strong>Agendamento:</strong> após confirmação de pagamento, o cliente recebe email com instruções para agendar/reagendar.</li>
// //         <li><strong>Reagendamento:</strong> gratuito até 24 horas antes. Dentro das 24 horas, poderá ser cobrada taxa administrativa (até 30%).</li>
// //         <li><strong>Cancelamento:</strong> pedidos até 24 horas antes têm reembolso integral; após esse prazo poderá não haver reembolso por indisponibilidade de agenda.</li>
// //         <li><strong>Não comparência:</strong> é considerada utilização do serviço, sem direito a reembolso.</li>
// //       </ul>

// //       <h2>Produtos Digitais (E-books, conteúdos descarregáveis)</h2>
// //       <ul>
// //         <li><strong>Entrega:</strong> disponibilização imediata por link de download e/ou envio por email.</li>
// //         <li><strong>Devolução:</strong> por natureza digital e acesso imediato, <strong>não há direito de devolução</strong> após o download/entrega do link.</li>
// //         <li><strong>Links expirados:</strong> reativação gratuita mediante validação do pedido e prova de compra.</li>
// //       </ul>

// //       <h2>Prazo de Entrega</h2>
// //       <p>
// //         Serviços digitais: imediato. Terapias presenciais/online: conforme agenda acordada com o cliente.
// //       </p>

// //       <h2>Faturação e Recibos</h2>
// //       <p>
// //         O cliente recebe <strong>recibo</strong> após pagamento com os dados do comerciante. As segundas vias podem ser obtidas
// //         em <code>/recibo/&lt;id&gt;</code> ou mediante pedido para <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.
// //       </p>

// //       <h2>Contacto</h2>
// //       <p>Email: <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a> • WhatsApp: (+238) 939 4185</p>
// //     </section>
// //   );
// // }
// import React from "react";

// export default function PoliticaEntrega() {
//   const today = new Date().toISOString().slice(0, 10);

//   return (
//     <section className="container py-4">
//       <h1>Política de Entrega e Devolução de Produtos e/ou Serviços</h1>
//       <p>
//         Última atualização: <time dateTime={today}>{today}</time>
//       </p>

//       <h2>Âmbito</h2>
//       <p>
//         Esta política aplica-se aos serviços prestados por <strong>Luciana Costa</strong> no website
//         <strong> lucianacosta.cv</strong>, incluindo terapias presenciais e online, e a produtos digitais
//         (ex.: e-books). A faturação e o processamento de pagamentos são efetuados por{" "}
//         <strong>MIT Solutions, Lda.</strong> (NIF 284004405), merchant de referência junto do SISP/Vinti4.
//       </p>

//       <h2>Serviços (Terapias)</h2>
//       <ul>
//         <li>
//           <strong>Agendamento:</strong> após confirmação do pagamento, o cliente recebe e-mail com
//           instruções para <strong>agendar</strong> e/ou <strong>reagendar</strong> a sessão.
//         </li>
//         <li>
//           <strong>Reagendamento:</strong> <span className="text-success fw-semibold">gratuito</span>,{" "}
//           <span className="text-muted">sujeito à disponibilidade de vaga</span>.
//         </li>
//         <li>
//           <strong>Cancelamento:</strong> <span className="text-success fw-semibold">gratuito</span>; o
//           valor pago é <strong>reembolsado integralmente</strong>.
//         </li>
//         <li>
//           <strong>Não comparência (no-show):</strong> é considerada utilização do serviço, sem direito a
//           reembolso.
//         </li>
//       </ul>

//       <h2>Produtos Digitais (E-books e conteúdos descarregáveis)</h2>
//       <ul>
//         <li>
//           <strong>Entrega:</strong> disponibilização imediata por link de download e/ou envio por e-mail.
//         </li>
//         <li>
//           <strong>Devolução:</strong> por natureza digital e acesso imediato, <strong>não há direito de devolução</strong> após o
//           download/entrega do link.
//         </li>
//         <li>
//           <strong>Links expirados:</strong> reativação gratuita mediante validação do pedido e prova de
//           compra.
//         </li>
//       </ul>

//       <h2>Prazo de Entrega</h2>
//       <p>
//         Serviços digitais: imediato. Terapias presenciais/online: conforme agenda acordada com o cliente.
//       </p>

//       <h2>Faturação e Recibos</h2>
//       <p>
//         O cliente recebe <strong>recibo</strong> após o pagamento, com os dados do comerciante. As segundas vias podem ser obtidas
//         em <code>/recibo/&lt;id&gt;</code> ou mediante pedido para{" "}
//         <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.
//       </p>

//       <h2>Contacto</h2>
//       <p>
//         E-mail: <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a> • WhatsApp: (+238) 939 4185
//       </p>
//     </section>
//   );
// }
import React from "react";

export default function PoliticaEntrega() {
  const today = new Date().toISOString().slice(0, 10);

  return (
    <section className="container py-4">
      <h1>Política de Entrega e Devolução de Produtos e/ou Serviços</h1>
      <p>
        Última atualização: <time dateTime={today}>{today}</time>
      </p>

      <h2>Âmbito</h2>
      <p>
        Esta política aplica-se aos serviços prestados por <strong>Luciana Costa</strong> no website
        <strong> lucianacosta.cv</strong>, incluindo terapias presenciais e online, e a produtos digitais
        (ex.: e-books). A faturação e o processamento de pagamentos são efetuados por{" "}
        <strong>MIT Solutions, Lda.</strong> (NIF 284004405), merchant de referência junto do SISP/Vinti4.
      </p>

      <h2>Serviços (Terapias)</h2>
      <ul>
        <li>
          <strong>Pedido de agendamento:</strong> No site o cliente faz o pedido de agendamento (formulário).
        </li>
        <li>
          <strong>Pagamento:</strong> Após confirmarmos a disponibilidade de vaga, enviamos e-mail/WhatsApp
          com as opções de pagamento (link SISP/Vinti4, transferência).
        </li>
        <li>
          <strong>Reagendamento:</strong>{" "}
          <span className="text-success fw-semibold">gratuito</span>,{" "}
          <span className="text-muted">sujeito à disponibilidade de vaga</span>.
        </li>
        <li>
          <strong>Cancelamento:</strong>{" "}
          <span className="text-success fw-semibold">gratuito</span>; caso já exista pagamento,
          é efetuado <strong>reembolso integral</strong>.
        </li>
        <li>
          <strong>Não comparência (no-show):</strong> é considerada utilização do serviço, sem direito a
          reembolso.
        </li>
      </ul>

      <h2>Produtos Digitais (E-books e conteúdos descarregáveis)</h2>
      <ul>
        <li>
          <strong>Entrega:</strong> disponibilização imediata por link de download e/ou envio por e-mail.
        </li>
        <li>
          <strong>Devolução:</strong> por natureza digital e acesso imediato,{" "}
          <strong>não há direito de devolução</strong> após o download/entrega do link.
        </li>
        <li>
          <strong>Links expirados:</strong> reativação gratuita mediante validação do pedido e prova de
          compra.
        </li>
      </ul>

      <h2>Prazo de Entrega</h2>
      <p>
        Serviços digitais: imediato. Terapias presenciais/online: conforme agenda acordada com o cliente.
      </p>

      <h2>Faturação e Recibos</h2>
      <p>
        O cliente recebe <strong>recibo</strong> após o pagamento, com os dados do comerciante. As segundas
        vias podem ser obtidas em <code>/recibo/&lt;id&gt;</code> ou mediante pedido para{" "}
        <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.
      </p>

      <h2>Contacto</h2>
      <p>
        E-mail: <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a> • WhatsApp: (+238) 939 4185
      </p>
    </section>
  );
}
